export class AuthorEPTModel {
  authorArticleListApi: string = "";
  authorDownloadFileApi: string = "";
  authorCorrectionApi: string = "";
  authorApproveApi: string = "";
  authorCorrectionDownloadFileApi: string = "";
  articleAuthorDetailsApi: string = "";
}
